module.exports = __webpack_public_path__ + "static/img/bg01.f73e731.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/personagens/bg/bg01.jpg
// module id = 746
// module chunks = 2 3 4 5 27